import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { getUser } from '../reducers/auth';
import SubsiteService from '../services/subsite.service';
import { useForm } from "react-hook-form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import AddressModal from "./modals/AddressModal";


const ChooseSubsiteAddress = ({close}) => {
    const user = useSelector(getUser);
    const [addresses, setAddresses] = React.useState([]);
    const [selectedAddressId, setSelectedAddressId] = React.useState(null);
    const [showModal, setShowModal] = React.useState(false);
    const [currentAddress, setCurrentAddress] = React.useState({});



    useEffect(() => {
        console.log("USER IN ADDRESS MODAL", user);
        const fetchAddresses = async () => {
            const response = await SubsiteService.getSubsiteAddresses();
            setAddresses(response.data);
            if (response.data.length > 0)
                setSelectedAddressId(response.data[0].id);
        };
        fetchAddresses();
    }, []);


    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: { name: user.firstname + " " + user.lastname},
    });
    
    const {
        register: register2,
        formState: { errors: errors2 },
        handleSubmit: handleSubmit2,
      } = useForm();

    const onChangeSubmit = async (addressId) => {
        console.log("ON CHANGE SELECTED ADDRESS", selectedAddressId);
        close(true, addresses.find(a => a.id == selectedAddressId));
    }

    const addressModalClose = () => {
        close(false);
    }

    const closeAddressModal = (updatedAddress) => {
        setShowModal(false);
        if (updatedAddress) {
            var currAddresses = addresses;
            for (var i = 0; i < currAddresses.length; i++) {
                if (currAddresses[i].id == updatedAddress.id) {
                    currAddresses[i] = updatedAddress;
                    break;
                }
            }
            setAddresses(currAddresses);
        }
        setCurrentAddress(null);
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h4>Addresses:</h4>
                </Col>
            </Row>
            <Form onSubmit={handleSubmit2(onChangeSubmit)}>
                {addresses && addresses.map((address, index) => {
                    return (
                        <Row style={{margin: 10, padding: 5, border: "1px solid #CCCCCC"}} key={index}>
                            <Col xs={8}>
                                    <h5>
                                      <input type="radio" name="address" selected={selectedAddressId && address.id == selectedAddressId} onChange={() => setSelectedAddressId(address.id)} />{" "}
                                      {address.name
                                        ? `${address.name}:`
                                        : <em style={{ fontWeight: "normal", color: "#666" }}>Ship to your name:</em>}
                                    </h5>
                                    <div style={{ marginLeft: 20 }}>{address.street}<br />
                                        {address.street2 != null && address.street2 != "" && <>{address.street2}<br /></>}
                                        {address.city}, {address.state} {address.zipCode}
                                    </div>
                            </Col>
                        </Row>
                    )
                })}
                <Row>
                    <Col>
                        <Button variant="danger" onClick={addressModalClose}>
                            Cancel
                        </Button>
                        &nbsp;
                        {selectedAddressId && <Button variant="success" onClick={handleSubmit2(onChangeSubmit)} type="submit">
                            Choose Address
                        </Button>}
                    </Col>
                </Row>
            </Form>
            <Row>
                <Col>
                    <hr />
                </Col>
            </Row>
            <Row>
                <Col>
                    <hr />
                </Col>
            </Row>

        </Container>
    );
};

export default ChooseSubsiteAddress; 